import { render, staticRenderFns } from "./BusinessUnitDetailsTable.vue?vue&type=template&id=39f9ea2c&"
import script from "./BusinessUnitDetailsTable.vue?vue&type=script&lang=js&"
export * from "./BusinessUnitDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports